/**
 * The title and login screen: ink spreading on silk. Guqin harmonics ring like drops of ink, the
 * xiao breathes under them, a bowl now and then. Slow and open, for the animated ink-wash login; the lofi finish (lofi-front.ts) adds a soft beat and a warm comp.
 */
import { drone, vary } from '../compose';
import { registerTrack } from '../registry';
import { lofify } from './lofi-front';

// 泛音 first, then stopped notes with 绰 slides and a 吟 on the low tonic.
const A = `@mp 6* 1'*_ 2'*_ 3'*- | 2'*_ 1'*_ 6* 5*- | 6*. 5*_ 3* 2* | 3*--- |
  @mf 6,/ 1_ 2_ 3\\- | 5,/- 6,~- | 1_ 6,_ 5, 3,/ 2, | 6,,~---`;
const A_XIAO = `0--- | 0--- | 0--- | 0--- | @p 0- 6,- | 1. 2_ 3- | 2_ 1_ 6,- 5, | 6,---`;

const B_XIAO = `@mp 6. 1'_ 6 5 | 3- 2 3 | 5. 6_ 5_ 3_ 2 | 1--- ; |
  2. 3_ 5 6 | 1'- 6 5 | 3_ 5_ 3_ 2_ 1 2 | 6,---`;
const B_QIN = `@mp 6,,- 3,- | 5,,- 2,/- | 3,,~- 6,,- | 1,~--- | 2,- 5,- | 6,- 3,\\- | 5,,- 1,- | 6,,~---`;

const C_QIN = `@p 3'* 2'* 6* 0 | 5'*- 3'*- | 2'*_ 3'*_ 2'*_ 1'*_ 6*- | 6*---`;

registerTrack(lofify({
  id: 'login',
  order: 1,
  title: 'หมึกซึมผืนไหม',
  mood: 'สงบ ลึกล้ำ ภาพวาดหมึกจีน',
  use: 'หน้าจอเข้าสู่ระบบ / หน้าแรก',
  key: 'F',
  mode: 'yu',
  bpm: 56,
  meter: 4,
  seed: 101,
  humanize: 0.6,
  parts: {
    qin: { inst: 'qin', pan: 0.08, reverb: 0.55 },
    xiao: { inst: 'xiao', gain: 0.85, pan: -0.2, reverb: 0.6 },
    pad: { inst: 'pad', gain: 0.6, reverb: 0.6 },
    bowl: { inst: 'perc', gain: 0.22, pan: 0.25, reverb: 0.7 },
  },
  intro: ['I'],
  sections: {
    I: {
      bars: 2,
      parts: {
        qin: `@p 6'* 0 3'* 0 | 2'*- 6*-`,
        bowl: `b--- | 0---`,
      },
    },
    A: {
      bars: 8,
      parts: {
        qin: A,
        xiao: A_XIAO,
        pad: drone(`6,, 6,, 5,, 6,, 6,, 5,, 6,, 6,,`, 4),
        bowl: `b--- | 0--- | 0--- | 0--- | b--- | 0--- | 0--- | 0---`,
      },
    },
    B: {
      bars: 8,
      parts: {
        xiao: B_XIAO,
        qin: B_QIN,
        pad: drone(`6,, 5,, 3,, 1, 2, 6,, 5,, 6,,`, 4),
        bowl: `b--- | 0--- | 0--- | 0--- | b--- | 0--- | 0--- | 0---`,
      },
    },
    A2: {
      bars: 8,
      parts: {
        qin: vary(A, 6, `1_ 6,_ 5,_ 3,_ 2, 3,`),
        xiao: `@p 0--- | 0--- | 6. 5_ 3 2 | 3--- ; | 0- 6,- | 1. 2_ 3- | 2_ 1_ 6,- 5, | 6,---`,
        pad: drone(`6,, 6,, 5,, 6,, 6,, 5,, 6,, 6,,`, 4),
        bowl: `b--- | 0--- | 0--- | 0--- | b--- | 0--- | 0--- | 0---`,
      },
    },
    C: {
      bars: 4,
      bpm: 50,
      rit: 0.85,
      parts: {
        qin: C_QIN,
        pad: drone(`6,, 3,, 6,, 6,,`, 4),
        bowl: `b--- | 0--- | 0--- | b---`,
      },
    },
  },
  form: ['A', 'B', 'A2', 'C'],
  loop: true,
}, { bpm: 60, beat: 'soft' }));
